export{Badge,BadgeIndicator}from"@vds-core/badges";
